import React from 'react';
import E3 from '../img/E3-logo.png';
import Bridge2 from '../img/Bridge2-logo.png';
import i2E from '../img/i2E-logo.png';
import PlainsVentures from '../img/plains-ventures-logo.png';
import SamDuRegger from '../img/Sam_DuRegger.jpg';
import EmojiConversations from '../components/EmojiConversations.jsx';
import featureImage from '../img/wink-bot.svg';
import featureImageOne from '../img/Square_POS.png';
import featureImageTwo from '../img/DROPS.png';
import BotLogo from '../img/bot.svg';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import BrandLink from '../components/BrandLink';
import { LINKS } from '../constants';
import { personas } from '../personas/personas';
import Brian_square from '../personas/images/Brian_square.jpg';
import Francis_square from '../personas/images/Francis_square.jpg';
import Fred_square from '../personas/images/Fred_square.jpg';

const personaPortraits = {
  brian: Brian_square,
  francis: Francis_square,
  fred: Fred_square,
};

const personaCardCopy = {
  brian: 'Coffee shop owner, community builder, and operational efficiency.',
  francis: 'Friends, work, pilates, matcha, and personalized order shortcuts.',
  fred: 'Millennial, full-stack developer, and work-from-home coffee aficionado.',
};




const HomePage = () => {
  return (
	<main>
	  <HeroSection />
	  <FeaturesSection />
	  <FundingSection />
	  <BookSection />
	  <ContactSection />
	  <Footer />
	</main>
  );
};

const HeroSection = () => (
  <section className="hero">
	<h1>Text your <span role="img" aria-label="coffee">☕️</span> order like you text a friend.</h1>
	<p>Add an emoji to your favorite order to fast-track your next order!</p>
	<EmojiConversations />
  </section>
);
	
	const FeaturesSection = () => (
	  <section className="features-section">
		<div className="features-header">
		  <h1>For Coffee Shops - Barista Bot <u>automates</u> orders and payments so baristas can focus on quality drinks and service.</h1>
		  <div className="header-image-container">
			<img src={featureImage} alt="Feature" className="feature-image" />
		  </div>
		</div>
	  <div className="features-body">
			<div className="feature-item1">
			  <h4>SQUARE POS</h4> {/* Assuming you want an h4 based on your CSS */}
			  <h3>Integrated order and payment.</h3>
			  <p>Integrated with Square POS. Works seamlessly with Order Ahead—no workflow changes. It looks and acts like a mobile order.</p>
			  {/* Assuming featureImageOne import */}
			  <img src={featureImageOne} alt="Drops Feature" className="body-feature-image" />
			</div>
			<div className="feature-item2">
			  <h4>DROPS</h4> {/* Similar assumption for h4 */}
			  <h3>Coming Soon!</h3>
			  <p>Send a text with a picture and tasting notes of your new coffee. They reply "yes" and we charge their card. No promo codes or links—everything happens in the text.</p>
			  {/* Assuming featureImageTwo import */}
			  <img src={featureImageTwo} alt="Specials Feature" className="body-feature-image" />
			</div>
		  </div>
		</section>
	  );
	
	
	
	const FundingSection = () => {
		return (
		<section className="funding">
			<h1>Funding</h1>
			<p>Barista Bot is an AI-powered, text-based ordering system that integrates with POS systems to streamline ordering and drive revenue. After launching our pilot with pre-seed financing from i2E & Plains Ventures, <BrandLink href={LINKS.espressoPlusMilk}>Espresso + Milk, LLC</BrandLink> is seeking a small round of funding.</p>
			<div className="funding-buttons">
				<Link to="./pitch-deck"><button className="char-button">PITCH DECK</button></Link>
				<a href="https://www.dropbox.com/scl/fi/d88qx95ecqo01nl41o2on/Barista_Bot_Exec_Summary.pdf?rlkey=6wdnwhix6fz5exf2q1nhet7ux&dl=0" target="_blank" rel="noopener noreferrer" download="Barista_Bot_ExecSummary.pdf"><button className="char-button">EXECUTIVE SUMMARY</button></a>
			</div>
			
			<div className="partner-boxes">
			  <div className="partner-box1">
				<span>AUGUST 2023</span>
				<img src={E3} alt="E3" className="funding-image1" />
				<p>Completed i2E’s E3’s micro-accelerator program.</p>
			  </div>
			  <div className="partner-box1">
				<span>January 2024</span>
				<img src={Bridge2} alt="Bridge2" className="funding-image2" />
				<p>Completed i2E’s inaugural pre-accelerator Bridge2.</p>
			  </div>
			  <div className="partner-box2">
				<span>Venture Partner</span>
				<img src={i2E} alt="i2E" className="funding-image3" />
				<p>Funded by Accelerate Oklahoma, a funding arm of OCAST and i2E.</p>
			  </div>
			  <div className="partner-box2">
				<span>Venture Partner</span>
				<img src={PlainsVentures} alt="Plains Ventures" className="funding-image4" />
				<p>Funded by Oklahoma Seed Fund, a Plains Venture Fund.</p>
			  </div>
			  {/* Add the other two boxes in a similar fashion */}
			</div>
			 <h3>Get in Touch</h3>
			  <div className="funding-contact-container">
					  
					  <div className="funding-image-container">
						<img src={SamDuRegger} alt="Sam DuRegger" className="funding-image-circle" />
					  </div>
					  <div className="funding-info-container">
						<p>Seed Investors, Angels, and VCs: Schedule a coffee at our new studio space to learn about Barista Bot's roadmap and capital structure.</p>
					  </div>
					  <div className="funding-button-container">
						<a href="https://calendar.app.google/kE1Qe9Ttqn9UKL8SA" target="_blank" rel="noopener noreferrer"><button className="char-button-stacked">BOOK COFFEE  ↗</button></a>
						<a href="mailto:sam@beginthework.com" ><button className="char-button-stacked">SEND AN EMAIL  ↗</button></a>
					  </div>
					</div>
		</section>
				);
			  };
	
	const BookSection = () => {
		return (
			<section className="book-demo-section">
				<div className="book-demo-content-wrapper">
					<div className="book-demo-content">
						<h1>Book a Demo in OKC</h1>
						<p>See Barista Bot's Square POS integration in action. We'll walk through menu import, the ordering flow, and how emoji shortcuts work. Free coffee and a Barista Bot mug included.</p>
						<div className="book-demo-button-container">
							<a href="https://calendar.app.google/kE1Qe9Ttqn9UKL8SA" target="_blank" rel="noopener noreferrer">
								<button className="submit-button">Book a Demo in OKC ↗</button>
							</a>
						</div>
					</div>
					<div className="book-demo-map">
						<iframe
							src="https://www.google.com/maps?q=219+NW+12th+St+Suite+23+Oklahoma+City+OK+73103&output=embed"
							width="100%"
							height="300"
							style={{ border: 0, borderRadius: '24px' }}
							allowFullScreen=""
							loading="lazy"
							referrerPolicy="no-referrer-when-downgrade"
							title="Barista Bot Studio Location - 219 NW 12th St, Suite 23, Oklahoma City, OK 73103"
							className="book-demo-map-iframe"
						></iframe>
					</div>
				</div>
			</section>
		);
	};


const ContactSection = () => {
	  return (
		<section className="contact-section">
		  <div className="contact-header-wrapper">
			<h1>Are you a coffee shop?</h1>
			<div className="contact-logo-container">
				<img src={BotLogo} alt="Barista Bot Logo" className="contact-logo" />
			</div>
		  </div>
		  <div className="contact-content">
			  <p>Beta is open. If you use Square POS, join early and get instant access to our growing customer base. Your customers can sign up and order via text—no app download required.</p>
			  <p>Limited spots available. Be among the first coffee shops to offer text-based ordering.</p>
			  <a href="mailto:sam@beginthework.com" ><button className="submit-button">Join the Beta ↗</button></a>
			</div>
			<div className="persona-intro">
			  <h3>See it through their day</h3>
			  <p>A shop owner, a regular, and a work-from-home customer. Three stories about how text ordering fits a real café — and why shops join the beta.</p>
			  <div className="partner-boxes persona-cards">
				{personas.map((persona) => (
				  <Link
					key={persona.slug}
					to={`/personas/${persona.slug}`}
					className="partner-box1 persona-card"
				  >
					<img
					  src={personaPortraits[persona.slug]}
					  alt={persona.name}
					  className="funding-image-circle persona-card-photo"
					/>
					<span className="persona-card-name">{persona.name}</span>
					<p>{personaCardCopy[persona.slug]}</p>
					<button type="button" className="char-button-medium">Read story</button>
				  </Link>
				))}
			  </div>
			  <Link to="/personas" className="persona-intro-all">Meet all three personas →</Link>
			</div>
		</section>
	  );
	};


export default HomePage;


